import React, { useState, useEffect } from 'react'
import { Box } from '@material-ui/core'

const motionIconSwitch = (motionIcon) => {
    switch (motionIcon) {
    case 'backpack': return 'motion-icons/backpack.gif'
    case 'heart': return 'motion-icons/heart.gif'
    case 'rocket': return 'motion-icons/rocket.gif'
    case 'smiley': return 'motion-icons/blinking-smiley.gif'
    case 'star': return 'motion-icons/star.gif'
    case 'speaker': return 'motion-icons/speakers.gif'
    case 'fork-knife-rotate': return 'motion-icons/fork-knife-rotate.gif'
    case 'bag': return 'motion-icons/bag.gif'
    case 'book': return 'motion-icons/book.gif'
    case 'box': return 'motion-icons/box.gif'
    case 'brain': return 'motion-icons/brain.gif'
    case 'camembert': return 'motion-icons/camembert.gif'
    case 'carrots': return 'motion-icons/carrots.gif'
    case 'chemist': return 'motion-icons/chemist.gif'
    case 'clock': return 'motion-icons/clock.gif'
    case 'court': return 'motion-icons/court.gif'
    case 'danger': return 'motion-icons/danger.gif'
    case 'desktop': return 'motion-icons/desktop.gif'
    case 'diagram': return 'motion-icons/diagram.gif'
    case 'euro': return 'motion-icons/euro.gif'
    case 'facebook': return 'motion-icons/facebook.gif'
    case 'fire': return 'motion-icons/fire.gif'
    case 'flash': return 'motion-icons/flash.gif'
    case 'globe-rotate': return 'motion-icons/globe-rotate.gif'
    case 'grade': return 'motion-icons/grade.gif'
    case 'hammer': return 'motion-icons/hammer.gif'
    case 'happy-smile-stars': return 'motion-icons/happy-smile-stars.gif'
    case 'human': return 'motion-icons/human.gif'
    case 'idea': return 'motion-icons/idea.gif'
    case 'ig': return 'motion-icons/ig.gif'
    case 'laughing-tears-smiley': return 'motion-icons/laughing-tears-smiley.gif'
    case 'linkedin': return 'motion-icons/linkedin.gif'
    case 'megaphone': return 'motion-icons/megaphone.gif'
    case 'money': return 'motion-icons/money.gif'
    case 'moon': return 'motion-icons/moon.gif'
    case 'namaste': return 'motion-icons/namaste.gif'
    case 'paint': return 'motion-icons/paint.gif'
    case 'party': return 'motion-icons/party.gif'
    case 'pen': return 'motion-icons/pen.gif'
    case 'pig-money': return 'motion-icons/pig-money.gif'
    case 'rocket_1': return 'motion-icons/rocket_1.gif'
    case 'sad-face': return 'motion-icons/sad-face.gif'
    case 'safety-case': return 'motion-icons/safety-case.gif'
    case 'schoolbag': return 'motion-icons/schoolbag.gif'
    case 'settings': return 'motion-icons/settings.gif'
    case 'spaceship': return 'motion-icons/spaceship.gif'
    case 'support': return 'motion-icons/support.gif'
    case 'telescope': return 'motion-icons/telescope.gif'
    case 'thinkof': return 'motion-icons/thinkof.gif'
    case 'thumbup': return 'motion-icons/thumbup.gif'
    case 'tiktok': return 'motion-icons/tiktok.gif'
    case 'tool': return 'motion-icons/tool.gif'
    case 'unicorn': return 'motion-icons/unicorn.gif'
    default: return '/'
    }
}

const MotionIconFactory = ({ motionIcon, delay = 0 }) => {
    const [showAnimation, setShowAnimation] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowAnimation(true)
        }, delay)

        return () => clearTimeout(timer)
    }, [delay])

    const gifUrl = `http://res.cloudinary.com/studentbe/image/upload/fl_animated/c_fill,h_150,w_150/f_auto,q_auto/v1/${motionIconSwitch(motionIcon)}`

    return (
        <Box>
            {showAnimation &&
                <img
                    src={gifUrl}
                    alt={`A cool animated GIF - ${motionIcon}`}
                    width='150'
                    height='150'
                />
            }
        </Box>
    )
}
export default MotionIconFactory
